import api from '../api/icaro';

export async function getLocations() {
  const { data } = await api.get('/locations');
  return data;
}

// Buscar item por ID
export async function getLocation(id) {
  const { data } = await api.get(`/locations/${id}`);
  return data;
}

// Criar item
export async function storeLocation(item) {
  const { data } = await api.post('/locations', item);
  return data;
}

// Atualizar item
export async function updateLocation(id, item) {
  const { data } = await api.put(`/locations/${id}`, item);
  return data;
}

// Excluir item
export async function deleteLocation(id) {
  await api.delete(`/locations/${id}`);
}